<template>
    <div class="snippet-network">
        <div class="image">
            <img v-if="imageUrlDefault || imageUrl" :src="imageUrlDefault || imageUrl"/>
            <img v-else :src="require('../../../assets/img/localhost-file-not-found.jpg')">
        </div>
       
        <div class="content">
            <p class="domaine" v-if="domaineDefault || domaine">{{ domaineDefault || domaine }}</p>
            <p class="title" v-if="titleDefault || title">{{ titleDefault || title }}</p>
            <p class="description" v-if="descriptionDefault || description">{{ descriptionDefault || description }}</p>
        </div>
    </div>
</template>

<script>
import Posts from './../../mixins/Posts'
export default {
    props: {
        link: {
            type: String,
            default: "https://www.youtube.com/watch?v=m2jzfVF7noA" 
        },
        imageUrlDefault: {
            type: String,
            default: "" 
        },
        domaineDefault: {
            type: String,
            default: "" 
        },
        titleDefault: {
            type: String,
            default: "" 
        },
        descriptionDefault:{
            type: String,
            default: "" 
        },
        network: {
            type: String,
            default: "" 
        },
        autoComplete: {
            type: Boolean,
            default: true
        },
        timeoutGetNewsMeta : null,


    },
    mixins: [Posts],
    data() {
        return {
            imageUrl: "",
            domaine: "",
            title: "",
            description: "",
            timeoutInitSearch : null
        }
    },

    methods: {
        getMeta(){

            if (this.autoComplete && this.link) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.title = this.getHostname(this.link)
                this.description = this.getHostname(this.link)
                this.imageUrl = null
                this.timeoutInitSearch = setTimeout(() => {
                    this.getNewsMeta(this.link).then(res => {
                        const { success, meta } = res.body

                        if (!success || success !== true) { 
                            this.title = this.getHostname(this.link)
                            this.description = this.getHostname(this.link)
                            this.domaine = this.getHostname(this.link)
                            return
                        }
                        this.domaine = this.getHostname(this.link)
                        this.imageUrl = meta.og && meta.og.image ? meta.og.image : meta.image && meta.image[0] ? meta.image[0].url : null
                        this.title = meta.og.title || meta.meta.title
                        this.description = meta.og.description || meta.meta.description

                        // switch (network) {
                        //     case 'linkedin':
                                
                        //         break;
                        
                        //     default:
                        //         break;
                        // }
                    
                    })
                },1000)
              
            }
           
             
        },

        getHostname(url) {
            return (new URL(url)).hostname.replace("www.", "");
        },
    },

    mounted () {
        this.getMeta()
    },

    watch: {
        link(newValue, oldValue) {
            this.getMeta()
        }
    },
}
</script>
